import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {
  IconEnum,
  ControlSizeEnum,
  ControlTypeColorEnum,
  AvatarTypeEnum,
  DialogRef
} from 'datnek-ds';

@Component({
  selector: 'nk-shared-dialog-connect-api-google-yahoo',
  templateUrl: './dialog-connect-api-google-yahoo.component.html',
  styleUrls: ['./dialog-connect-api-google-yahoo.component.scss'],
})
export class DialogConnectApiGoogleYahooComponent implements OnInit {
  iconEnum = IconEnum;
  sizeEnum = ControlSizeEnum;
  colorEnum = ControlTypeColorEnum;
  avatarEnum = AvatarTypeEnum;

  constructor(private router: Router, public dialogRef: DialogRef) {}

  ngOnInit(): void {}

  apiGoogleYahoConnect() {
    this.router.navigate(['/api-google-yahoo']);
  }
}
